
import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomInput from "../../Components/CustomInput/CustomInput";
import { toast, ToastContainer } from "react-toastify";
// import { useDispatch, useSelector } from "react-redux";
import OtpsSendModal from "../../Components/OtpSendModal/OtpsSendModal";
// import actions from "../../ReduxStore/actions";
import { useNavigate } from "react-router-dom";
import CustomInputLogin from "../../Components/CustomInputLogin/CustomInputLogin";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../ReduxStore/actions";
import CustomEmailVerifyInput from "../../Components/CustomEmailVerifyInput/CustomEmailVerifyInput";
// import { setInitialStateOfresetPasswordForCustomer } from "../../ReduxStore/Slices/VerificationOtp/resetPasswordForCustomer";
// import { setInitialStateOfEmailVerifyOtp } from "../../ReduxStore/Slices/VerificationOtp/EmailVerifyOtp";

const ForgotPasswordForm = ({ toggleSignIn }) => {
  const dispatch = useDispatch();

  const [showSetNewPassword, setShowSetNewPassword] = useState(false);


  const [resetPassword, setResetPassword] = useState();
  const navigate = useNavigate();
  // Component state
  const [isModalOpen, setModalOpen] = useState(false);
  const [submittedValues, setSubmittedValues] = useState("");
  const { EmailVerifyOtp } = useSelector(state => state?.EmailVerifyOtp);
  const { resetPasswordForUser } = useSelector(state => state?.resetPasswordForUser);




  // Modal handlers
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  // Formik initial values
  const initialValues = {
    email: "",
    password: "",
  };

  // Separate validation schemas
  const validationSchemaBeforeOTP = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });
  const [showNewPassword, setShowNewPassword] = useState(false)

  const validationSchemaAfterOTP = Yup.object({
    password: Yup.string().required("Password is required"),
  });

  const handleSubmit = async (values) => {
    console.log(values, "Values")
    handleOpenModal()
    try {
      if (EmailVerifyOtp?.message === "OTP verified successfully") {
        setShowSetNewPassword(true);
        const requestData = {
          data: {
            personal_email: values.email,
            newPassword: values.password,
          },
          method: "post",
          apiName: "resetPasswordForUser",
        };

        const newPasswordData = await dispatch(
          actions.RESETPASSWORDFORUSER(requestData)
        );

        console.log(
          newPasswordData,
          "newPasswordDatanewPasswordDatanewPasswordData"
        );
        if (
          newPasswordData?.payload?.message ===
          "Password has been reset successfully."
        ) {
          setShowSetNewPassword(false);
          setShowNewPassword(false)

          setResetPassword(newPasswordData);
          toast.success("Password has been reset successfully.");

          console.log("hejnjnknbkjbkjbky");

          // Await the state reset to ensure it completes before moving forward

          // Delay navigation to ensure user sees the success message
          // setTimeout(() => {
          toggleSignIn();
          // dispatch(setInitialStateOfEmailVerifyOtp());
          // dispatch(setInitialStateOfresetPasswordForCustomer());
          // }, 1500);

          setTimeout(() => {
            toggleSignIn();
            // dispatch(setInitialStateOfEmailVerifyOtp());
            // dispatch(setInitialStateOfresetPasswordForCustomer());
          }, 3000);
        } else {
          toast.error(
            newPasswordData?.payload?.message || "Failed to reset the password."
          );
        }
      } else {
        const requestData = {
          data: { email: values.email },
          method: "post",
          apiName: "sendOTP",
        };
        handleOpenModal();
        toast.success("OTP sent successfully.");

        const OtpSendData = await dispatch(actions.EMAILSENDOTP(requestData));

        if (OtpSendData?.payload?.message === "OTP sent successfully!") {
          // toast.success("OTP sent successfully.");
          setSubmittedValues(values.email); // Store email in the state
          // handleOpenModal();
        } else {
          toast.error("Please enter a valid email.");
        }
      }
    } catch (error) {
      console.error("Error during handleSubmit:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={
          showNewPassword
            ? validationSchemaAfterOTP
            : validationSchemaBeforeOTP
        }
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, setFieldValue }) => (
          <Form style={{ width: "100%" }}>
            <Box mb={2}>
              {/* Email Input */}
              {!showNewPassword && (
                <CustomInputLogin
                  name="email"
                  label="Email"
                  custPlaceholder="Enter Email"
                  inputType="email"
                />
              )}


              {showNewPassword && (
                <>
                  <CustomInput
                    name="email"
                    label="Email"
                    custPlaceholder="Enter Email"
                    inputType="text"
                    value={values.email}
                    readOnly
                  />
                  <CustomInput
                    name="password"
                    label="New password"
                    custPlaceholder="Enter New Password"
                    inputType="password"
                  />
                </>
              )}
            </Box>

            {/* Submit Button */}
            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{
                textTransform: "none",
                // borderRadius: 23,
                py: "7px",
                color: "white",
                backgroundColor: "var(--main-color)",
                "&:hover": {
                  backgroundColor: "var(--main-color)",
                },
              }}
              aria-label="Submit"
            >
              {showNewPassword
                ? "Reset password"
                : "Send OTP"}
              {/* Send OTP */}
            </Button>

            {/* OTP Modal */}
           
              <OtpsSendModal
                setShowNewPassword={setShowNewPassword}
                open={isModalOpen}
                onClose={handleCloseModal}
                submittedValues={submittedValues}
              />

            
            {/* Back Button */}
            {toggleSignIn && (
              <Typography
                variant="body1"
                onClick={toggleSignIn}
                sx={{
                  mt: 2,
                  textAlign: "center",
                  cursor: "pointer",
                  color: "var(--main-color)",
                }}
              >
                Go Back
              </Typography>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ForgotPasswordForm;
